import axios from '../utils/axios';

/**
 * Cross-team activity feed for the admin Activity screen.
 *
 * This is deliberately its own endpoint rather than a scope on `/sessions`:
 * every ordinary session read is hard-filtered to the caller's own team,
 * and an admin overview is the one place that must see past the silo.
 */

export interface AdminActivitySession {
  id: string;
  description: string;
  team_id: string;
  team_name: string;
  /** User-entered test date. Null when the session was never dated. */
  date: string | null;
  /** `date`, or the row's `edit_ts` when `date` is null. Drives the ordering. */
  activity_date: string | null;
  edit_ts: string | null;
  last_run_ts: string | null;
  hidden: boolean;
  analysis_type: number | null;
  run_count: number;
  warning_runs: number;
  error_runs: number;
  failed_runs: number;
  autocal_status: number;
  autocal_error: string | null;
  autocal_failed: boolean;
  has_warning: boolean;
}

export interface AdminActivityResponse {
  days: number;
  cutoff: string;
  sessions: AdminActivitySession[];
}

export function getAdminActivity(days: number): Promise<AdminActivityResponse> {
  return axios.get('/admin/activity', { params: { days } }).then((res) => res.data);
}
